import {
    getPreOrdersCts,
    getPreOrdersCurrentPage,
    getPreOrdersLastPage,
    getPreOrdersProjectAvailables,
    isLoading
} from '../../store/cut-to-size/reducers';
import {
    fetchPreOrdersCts,
    fetchPreOrdersCtsPaginate,
    fetchPreOrdersProjectAvailables,
    cancelPreorder
} from '../../store/cut-to-size/actions';
import { connect } from 'react-redux'
import PreOrdersCts from './PreOrdersCts'
import {defineMessages, injectIntl} from 'react-intl'
import { withRouter } from 'react-router-dom'


export const quotationMessages = defineMessages({
    CONFIRM_REJECT_ORDER: {
        id: 'sure_reject_quotation',
        description: 'sure_reject_quotation',
        defaultMessage: 'Are you sure to reject this quotation?'
    },
    CONFIRM_REJECT_PREORDER_ADVISE: {
        id: 'if_cancel_quotation',
        description: 'if_cancel_quotation',
        defaultMessage: 'If you cancel now, you’ll permanently remove this quotation.'
    },
    CONFIRM_REJECT_PREORDER_OK_BUTTON: {
        id: 'yes_cancel_quotation',
        description: 'yes_cancel_quotation',
        defaultMessage: 'Yes, cancel this quotation'
    },
    CONFIRM_REJECT_PREORDER_CANCEL_BUTTON: {
        id: 'no_cancel_quotation',
        description: 'no_cancel_quotation',
        defaultMessage: 'No, continue with this quotation'
    },
    CONFIRM_APPROVE_QUOTATION: {
        id: 'CONFIRM_APPROVE_QUOTATION',
        description: 'CONFIRM_APPROVE_QUOTATION',
        defaultMessage: 'Approve this quotation?'
    },
    CONFIRM_APPROVE_PLAN: {
        id: 'CONFIRM_APPROVE_PLAN',
        description: 'CONFIRM_APPROVE_PLAN',
        defaultMessage: 'Approve this plan?'
    },
    CONFIRM_APPROVE_PREORDER_OK_BUTTON: {
        id: 'CONFIRM_APPROVE_PREORDER_OK_BUTTON',
        description: 'CONFIRM_APPROVE_PREORDER_OK_BUTTON',
        defaultMessage: 'Yes, approve this preorder'
    },
    CONFIRM_APPROVE_QUOTATION_OK_BUTTON: {
        id: 'CONFIRM_APPROVE_QUOTATION_OK_BUTTON',
        description: 'CONFIRM_APPROVE_QUOTATION_OK_BUTTON',
        defaultMessage: 'Yes, approve this quotation'
    },
    CONFIRM_APPROVE_PLAN_OK_BUTTON: {
        id: 'CONFIRM_APPROVE_PLAN_OK_BUTTON',
        description: 'CONFIRM_APPROVE_PLAN_OK_BUTTON',
        defaultMessage: 'Yes, approve this plan'
    },
    CONFIRM_APPROVE_PREORDER_CANCEL_BUTTON: {
        id: 'CONFIRM_APPROVE_PREORDER_CANCEL_BUTTON',
        description: 'CONFIRM_APPROVE_PREORDER_CANCEL_BUTTON',
        defaultMessage: 'Reconsider'
    },
    CONFIRM_APPROVE_PREORDER_ADVISE_TOP: {
        id: 'CONFIRM_APPROVE_PREORDER_ADVISE_TOP',
        description: 'CONFIRM_APPROVE_PREORDER_ADVISE_TOP',
        defaultMessage: 'You`ll not be able to cancel this preorder using the platform.'
    },
    CONFIRM_APPROVE_PREORDER_ADVISE_BOTTOM: {
        id: 'CONFIRM_APPROVE_PREORDER_ADVISE_BOTTOM',
        description: 'CONFIRM_APPROVE_PREORDER_ADVISE_BOTTOM',
        defaultMessage: 'If you want to cancel it you have to contact your center.'
    },
    CONFIRM_DENY_PREORDER: {
        id: 'CONFIRM_DENY_PREORDER',
        description: 'CONFIRM_DENY_PREORDER',
        defaultMessage: 'Need more changes?'
    },
    REQUESTED: {
        id: 'quotation_sent',
        description: 'quotation_sent',
        defaultMessage: 'Quotation sent'
    },
    TECHNICAL_REVIEW: {
        id: 'TECHNICAL_REVIEW',
        description: 'TECHNICAL_REVIEW',
        defaultMessage: 'Technical review'
    },
    CSTMR_APPROVAL: {
        id: 'available_quotation',
        description: 'available_quotation',
        defaultMessage: 'Available quotation'
    },
    CSTMR_PLAN_APPRV: {
        id: 'available_plan',
        description: 'available_plan',
        defaultMessage: 'Available plan'
    },
    ORDER_CREATED: {
        id: 'order_in_progress',
        description: 'order_in_progress',
        defaultMessage: 'Order in progress'
    },
    CANCELLED: {
        id: 'cancelled_quotation',
        description: 'cancelled_quotation',
        defaultMessage: 'Cancelled quotation'
    },
    CSTMR_CANCEL: {
        id: 'cancelled_quotation_by_customer',
        description: 'cancelled_quotation_by_customer',
        defaultMessage: 'Cancelled quotation by customer'
    },
    CONFIRM_DENY_QUOTATION_ADVISE: {
        id: 'confirm_deny_quotation_advise',
        description: 'confirm_deny_quotation_advise',
        defaultMessage: 'You can detail the changes you need in the chat, after clicking the “Yes” button'
    }
})


const mapStateToProps = (state, { match }) => {
    return {
        preOrdersCts: getPreOrdersCts(state),
        currentPage: getPreOrdersCurrentPage(state),
        lastPage: getPreOrdersLastPage(state),
        projectList:getPreOrdersProjectAvailables(state),
        isLoading: isLoading(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearPreOrderCts: () => {
            dispatch({ type: 'CLEAR_PRE_ORDERS_CTS' })
        },
        fetchPreOrdersCts: () => {
            dispatch(fetchPreOrdersCts())
        },
        fetchPreOrdersCtsPaginate: (startDate, endDate, filterProject, status, search, page) => {
            console.log('fetchPreOrdersCtsPaginate', startDate, endDate)
            dispatch(fetchPreOrdersCtsPaginate(startDate, endDate, filterProject, status, search, page))
        },
        fetchPreOrdersProjectAvailables:  () => {
            dispatch(fetchPreOrdersProjectAvailables())
        },
        cancelPreorder: (preorderId) => dispatch(cancelPreorder(preorderId))
    }
}

const PreOrdersCtsContainer = withRouter(
    injectIntl(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(PreOrdersCts)
    )
)

export default PreOrdersCtsContainer
